import React from "react";
import { useMicrosoftAuth } from "../../context/MicrosoftAuthContext";

const NavBar = ({ toggle, isCollapsed, pageTitle = "Dashboard" }) => {
  const { logout } = useMicrosoftAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="topbar">
      {/* Left side - Burger menu + Page title */}
      <div className="topbar-left">
        <button 
          className="burger-menu-button"
          onClick={toggle}
          aria-label="Toggle sidebar"
        >
          <img
            src="/assets/icons/burgermenu.svg"
            alt="Menu"
            className="burger-menu-icon"
          />
        </button>
        <h1 className="topbar-title">
          {pageTitle}
        </h1>
      </div>

      {/* Right side - Logout */}
      <div className="topbar-right">
        <button 
          className="logout-button"
          onClick={handleLogout}
        >
          <img
            src="/assets/icons/logout.svg"
            alt="Logout"
            className="logout-icon"
          />
          <span className="logout-text">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default NavBar;
